// extracted by mini-css-extract-plugin
module.exports = {"page":"record_page__3E_mY","section":"record_section__2O1yb","deviceSelectContainer":"record_deviceSelectContainer__31hjH","warning":"record_warning__1khht"};